// Error404.tsx — Co Marca — estilo plataforma, fondo blanco
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

const colors = {
    primary: '#c1348b',
    primaryDark: '#8f1f64',
    secondary: '#61257b',
    secondaryLight: '#8b3fa8',
    accent: '#ffd97c',
    accentDark: '#ea8406',
};

const css = `


.custom-scroll::-webkit-scrollbar { width: 6px; }
.custom-scroll::-webkit-scrollbar-track { background: transparent; }
.custom-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(97, 37, 123, 0.3);
    border-radius: 20px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
    background-color: rgba(97, 37, 123, 0.5);
}

@keyframes blobFloat {
    0%,100% { border-radius:60% 40% 30% 70%/60% 30% 70% 40%; }
    50%      { border-radius:30% 60% 70% 40%/50% 60% 30% 60%; }
}
@keyframes fadeUp {
    from { opacity:0; transform:translateY(24px); }
    to   { opacity:1; transform:translateY(0); }
}
@keyframes floatY {
    0%,100% { transform:translateY(0); }
    50%     { transform:translateY(-14px); }
}
@keyframes pulseD {
    0%,100% { box-shadow:0 0 0 0 rgba(193, 52, 139,.35); }
    50%     { box-shadow:0 0 0 6px rgba(193, 52, 139,0); }
}
@keyframes spinSlow { to { transform:rotate(360deg); } }
@keyframes glitch1 {
    0%,100% { clip-path:inset(0 0 95% 0); transform:translateX(0); }
    10%     { clip-path:inset(10% 0 80% 0); transform:translateX(-6px); }
    20%     { clip-path:inset(30% 0 50% 0); transform:translateX(6px); }
    30%     { clip-path:inset(60% 0 20% 0); transform:translateX(-4px); }
    40%     { clip-path:inset(80% 0 5%  0); transform:translateX(4px); }
    50%     { clip-path:inset(0 0 95% 0); transform:translateX(0); }
}
@keyframes glitch2 {
    0%,100% { clip-path:inset(0 0 95% 0); transform:translateX(0); }
    15%     { clip-path:inset(20% 0 70% 0); transform:translateX(5px); }
    25%     { clip-path:inset(50% 0 30% 0); transform:translateX(-5px); }
    35%     { clip-path:inset(70% 0 10% 0); transform:translateX(3px); }
    45%     { clip-path:inset(0 0 95% 0); transform:translateX(0); }
}

.err-page { font-family:'DM Sans',sans-serif; }
.err-fadeup { animation: fadeUp .7s cubic-bezier(.16,1,.3,1) both; }
.err-fadeup-1 { animation: fadeUp .7s .1s cubic-bezier(.16,1,.3,1) both; }
.err-fadeup-2 { animation: fadeUp .7s .22s cubic-bezier(.16,1,.3,1) both; }
.err-fadeup-3 { animation: fadeUp .7s .34s cubic-bezier(.16,1,.3,1) both; }
.err-fadeup-4 { animation: fadeUp .7s .46s cubic-bezier(.16,1,.3,1) both; }

.err-blob {
    animation: blobFloat 7s ease-in-out infinite;
}
.err-float {
    animation: floatY 4s ease-in-out infinite;
}

/* Número principal con glitch */
.err-num { position:relative; display:inline-block; }
.err-num::before,
.err-num::after {
    content: attr(data-text);
    position: absolute; inset: 0;
    font-size: inherit; font-weight: inherit;
    line-height: inherit; letter-spacing: inherit;
}
.err-num::before {
    color:var(--ad-link, #2854c5);
    animation: glitch1 4s infinite steps(1);
    opacity: .5;
}
.err-num::after {
    color:var(--ad-link, #2854c5);
    animation: glitch2 4s .2s infinite steps(1);
    opacity: .4;
}

.err-btn {
    display:inline-flex; align-items:center; gap:10px;
    background:linear-gradient(135deg,${colors.primary},${colors.primaryDark});
    color:#fff; border:none; border-radius:14px;
    padding:14px 32px; font-size:1rem; font-weight:800;
    cursor:pointer; text-decoration:none;
    font-family:'DM Sans',sans-serif;
    box-shadow:0 6px 20px rgba(193, 52, 139,.32);
    transition:all .25s cubic-bezier(.16,1,.3,1);
    animation:pulseD 3s 1.5s infinite;
}
.err-btn:hover {
    transform:translateY(-3px) scale(1.04);
    box-shadow:0 14px 32px rgba(193, 52, 139,.38);
}
.err-btn-ghost {
    display:inline-flex; align-items:center; gap:8px;
    background:#f8fafc; border:1.5px solid #e2e8f0;
    color:#374151; border-radius:14px;
    padding:14px 28px; font-size:1rem; font-weight:700;
    cursor:pointer; text-decoration:none;
    font-family:'DM Sans',sans-serif;
    transition:all .2s;
}
.err-btn-ghost:hover { background:#f1f5f9; transform:translateY(-2px); }

/* Dots grid */
.err-dots {
    display:grid;
    grid-template-columns:repeat(5,1fr);
    gap:7px;
    opacity:.08;
}
.err-dot { width:4px; height:4px; border-radius:50%; background:#0f172a; }
`;

const Error404 = () => {
    return (
        <Fragment>
            <style>{css}</style>
            <div className="err-page custom-scroll" style={{
                height: '100vh',
                background: 'var(--ad-surface, #fff)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 'clamp(40px,6vw,80px) clamp(20px,4vw,40px)',
                position: 'relative',
                overflowX: 'clip',
                overflowY: 'auto',
            }}>

                {/* ── Blob decorativo top-right ── */}
                <div className="err-blob" style={{
                    position: 'absolute', top: '-80px', right: '-80px',
                    width: 'clamp(280px,35vw,440px)', height: 'clamp(280px,35vw,440px)',
                    background: `linear-gradient(135deg, ${colors.primary}12, ${colors.secondary}0a)`,
                    zIndex: 0, pointerEvents: 'none',
                }}/>

                {/* ── Blob secundario bottom-left ── */}
                <div className="err-blob" style={{
                    position: 'absolute', bottom: '-60px', left: '-60px',
                    width: 'clamp(200px,25vw,320px)', height: 'clamp(200px,25vw,320px)',
                    background: `linear-gradient(135deg, ${colors.accent}18, ${colors.secondaryLight}0c)`,
                    zIndex: 0, pointerEvents: 'none',
                    animationDelay: '3s',
                }}/>

                {/* ── Dots esquina top-left ── */}
                <div className="err-dots" style={{ position: 'absolute', top: '48px', left: '48px', zIndex: 0 }}>
                    {Array.from({length:25}).map((_,i) => <div key={i} className="err-dot"/>)}
                </div>

                {/* ── Dots esquina bottom-right ── */}
                <div className="err-dots" style={{ position: 'absolute', bottom: '48px', right: '48px', zIndex: 0 }}>
                    {Array.from({length:25}).map((_,i) => <div key={i} className="err-dot"/>)}
                </div>

                {/* ── Círculo decorativo flotante ── */}
                <div style={{
                    position: 'absolute', top: '18%', left: '8%',
                    width: '60px', height: '60px', borderRadius: '50%',
                    border: `2px solid ${colors.accent}40`,
                    animation: 'spinSlow 14s linear infinite',
                    zIndex: 0, pointerEvents: 'none',
                }}/>
                <div style={{
                    position: 'absolute', bottom: '22%', right: '10%',
                    width: '40px', height: '40px', borderRadius: '50%',
                    border: `2px solid ${colors.secondaryLight}40`,
                    animation: 'spinSlow 10s linear infinite reverse',
                    zIndex: 0, pointerEvents: 'none',
                }}/>

                {/* ── Contenido central ── */}
                <div style={{
                    position: 'relative', zIndex: 1,
                    maxWidth: '680px', width: '100%',
                    textAlign: 'center',
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0',
                }}>

                    {/* Badge */}
                    <div className="err-fadeup" style={{ marginBottom: '24px' }}>
                        <span style={{
                            display: 'inline-flex', alignItems: 'center', gap: '7px',
                            background: `${colors.primary}10`, border: `1.5px solid ${colors.primary}22`,
                            borderRadius: '100px', padding: '6px 18px',
                            fontSize: '.75rem', fontWeight:'650', color:'var(--ad-link, #2854c5)',
                            letterSpacing: '.06em', textTransform: 'uppercase',
                        }}>
                            <span style={{
                                width: '7px', height: '7px', borderRadius: '50%',
                                background: colors.primary, display: 'inline-block',
                                animation: 'pulseD 2s infinite',
                            }}/>
                            Error de navegación
                        </span>
                    </div>

                    {/* ── Número 404 con glitch ── */}
                    <div className="err-float err-fadeup-1" style={{ marginBottom: '8px', lineHeight: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                            {/* 4 */}
                            <span className="err-num" data-text="4" style={{
                                fontSize: 'clamp(7rem,18vw,13rem)',
                                fontWeight:'650', color:'var(--ad-link, #2854c5)',
                                letterSpacing: '-.04em', lineHeight: 1,
                            }}>4</span>

                            {/* 0 — con icono de cara triste */}
                            <span style={{
                                fontSize: 'clamp(7rem,18vw,13rem)',
                                fontWeight:'650', color: colors.accent,
                                letterSpacing: '-.04em', lineHeight: 1,
                                position: 'relative', display: 'inline-block',
                            }}>
                                0
                                {/* Ojitos del cero */}
                                <span style={{
                                    position: 'absolute', top: '36%', left: '28%',
                                    width: '10%', height: '10%',
                                    background: colors.accentDark,
                                    borderRadius: '50%',
                                }}/>
                                <span style={{
                                    position: 'absolute', top: '36%', right: '28%',
                                    width: '10%', height: '10%',
                                    background: colors.accentDark,
                                    borderRadius: '50%',
                                }}/>
                            </span>

                            {/* 4 */}
                            <span className="err-num" data-text="4" style={{
                                fontSize: 'clamp(7rem,18vw,13rem)',
                                fontWeight:'650', color:'var(--ad-link, #2854c5)',
                                letterSpacing: '-.04em', lineHeight: 1,
                            }}>4</span>
                        </div>
                    </div>

                    {/* Barra de 4 colores */}
                    <div className="err-fadeup-1" style={{ display: 'flex', gap: '5px', marginBottom: '28px', justifyContent: 'center' }}>
                        {[colors.primary, colors.secondary, colors.accentDark, colors.secondaryLight].map((c, i) => (
                            <div key={i} style={{ height: '3px', width: i === 0 ? '28px' : '10px', borderRadius: '3px', background: c }}/>
                        ))}
                    </div>

                    {/* Título */}
                    <h2 className="err-fadeup-2" style={{
                        fontSize: 'clamp(1.5rem,4vw,2.4rem)',
                        fontWeight:'650', color: 'var(--ad-ink, #0f172a)',
                        letterSpacing: '-.03em', lineHeight: 1.15,
                        marginBottom: '16px',
                    }}>
                        ¡Ups! Página no encontrada
                    </h2>

                    {/* Descripción */}
                    <p className="err-fadeup-3" style={{
                        fontSize: 'clamp(.9rem,2vw,1.05rem)',
                        color: 'var(--ad-muted, #64748b)', fontWeight: '500',
                        lineHeight: 1.7, maxWidth: '480px',
                        marginBottom: '36px',
                    }}>
                        La página que buscas pudo haber sido eliminada, cambió de dirección o está temporalmente deshabilitada.
                    </p>

                    {/* Botones */}
                    <div className="err-fadeup-4" style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', justifyContent: 'center' }}>
                        <Link to="/" className="err-btn">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M2 8l6-6 6 6M3 7v7h4v-4h2v4h4V7" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Volver al Inicio
                        </Link>
                        <Link to="#" onClick={() => window.history.back()} className="err-btn-ghost">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                                <path d="M9 3L5 7.5 9 12" stroke="#374151" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Página anterior
                        </Link>
                    </div>

                    {/* Código de error sutil */}
                    <div className="err-fadeup-4" style={{ marginTop: '48px' }}>
                        <span style={{
                            display: 'inline-flex', alignItems: 'center', gap: '8px',
                            background: 'var(--ad-surface, #f8fafc)', border: '1.5px solid #f1f5f9',
                            borderRadius: '10px', padding: '8px 16px',
                            fontSize: '.72rem', fontWeight: '700', color: 'var(--ad-muted, #94a3b8)',
                            letterSpacing: '.08em', fontFamily: 'monospace',
                        }}>
                            <span style={{ color:'var(--ad-link, #2854c5)' }}>◆</span>
                            HTTP 404 · PAGE_NOT_FOUND
                            <span style={{ color:'var(--ad-link, #2854c5)' }}>◆</span>
                        </span>
                    </div>

                </div>
            </div>
        </Fragment>
    );
};

export default Error404;
